import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var arrow_right_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "m14.5 6.5-1 1 3.7 3.7H4v1.6h13.2l-3.7 3.7 1 1 5.6-5.5z" }) });
export {
  arrow_right_default as default
};
//# sourceMappingURL=arrow-right.js.map
